import './filterstags.style.css'

import { useTranslation } from "react-i18next";
import "../../translations/i18n";

const FiltersTags = ({filterId2Name, appliedFilters, onTagRemove}) => {

    const {t} = useTranslation();

    return Object.keys(filterId2Name).length !== 0 && (
     <div className="resources-selected-filters">
        {

//src={require('../../assets/img/resources/'+kind+'_'+id+big_ext+'.png')}
          Object.keys(appliedFilters).map((key,index)=>{
            return (
              appliedFilters[key].map((val,index)=>{
                const keys= ['actcat','lab','am','kw','q','type'];
                const names=[t('filtertags.actcat'),t('filtertags.lab'),t('filtertags.am'),t('filtertags.kw'),t('filtertags.q'),t('filtertags.type')];
                if (!keys.includes(key)) return;
                const hint = names[keys.indexOf(key)];
                const text=key==="q"?val:filterId2Name[key][val];
                return (
                  <span className="filter-tag" key={`${key}${val}`}>
                    <span className="filter-tag-text">
                      {
                       <img className={`tagicon`}
                       alt={hint}
                       title={hint}
                       src={require('../../assets/img/resources/tag_'+key+'.png')} 
                      />
                      }
                      {text}
                    </span>
                    <span className="filter-tag-remove" data-category={key} data-id={key!=='q'?parseInt(val):val} onClick={onTagRemove}>✕</span>
                  </span>
                )}))})
        }
     </div>
    )
  }

export default FiltersTags